document.addEventListener('click', (e) => {
    const target = e.target.closest('.reveal-password');

    if (!target) {
        return;
    }

    const input = target.parentNode.querySelector('input');
    const icon  = target.querySelector('i');

    icon.classList.toggle('fa-eye');
    icon.classList.toggle('fa-eye-slash');
    target.classList.toggle('revealed');

    if (target.classList.contains('revealed')) {
        input.setAttribute('type', 'text')
    } else {
        input.setAttribute('type', 'password')
    }
});
